export default __webpack_public_path__ + "9f3834d4201c879f288d3485c72a913a.webp";